// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navImg {
  margin-left: 1vw;
  margin-top: 1vh;
  margin-bottom: 1vh;
  width: 3%;
}

.headerlink {
  color: white;
  font-size: 1rem;
  font-weight: 700;
  padding-left: 0%;
  padding-right: 0%;
  margin-left: 2vw;
  margin-right: 3vw;
  margin-top: 3.5vh;
  margin-bottom: 0.5vw;
}

@media only screen and (max-height: 950px) {
  .headerlink {
    color: white;
    font-size: 1rem;
    font-weight: 700;
    padding-left: 0%;
    padding-right: 0%;
    margin-left: 2vw;
    margin-right: 3vw;
    margin-top: 4vh;
    margin-bottom: 0.5vw;
  }
  .navImg {
    width: 50px;
    /* height:auto */
  }
}

@media only screen and (max-width: 384px) {
  .navImg {
    margin-top: 1vh;
    margin-bottom: 1vh;
  }

  .headerlink {
    color: white;
    font-size: 0.71rem;
    font-weight: 700;
    padding-left: 0%;
    padding-right: 0%;
    margin-left: 2vw;
    margin-right: 3vw;
    margin-top: 3vh;
    margin-bottom: 0.5vw;
  }
}

@media only screen and (max-height: 384px) {
  .headerlink {
    color: white;
    font-size: 1rem;
    font-weight: 700;
    padding-left: 0%;
    padding-right: 0%;
    margin-left: 2vw;
    margin-right: 3vw;
    margin-top: 6vh;
    margin-bottom: 0.5vw;
  }
  .navImg {
    width: 50px;
    /* height:auto */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".navImg {\n  margin-left: 1vw;\n  margin-top: 1vh;\n  margin-bottom: 1vh;\n  width: 3%;\n}\n\n.headerlink {\n  color: white;\n  font-size: 1rem;\n  font-weight: 700;\n  padding-left: 0%;\n  padding-right: 0%;\n  margin-left: 2vw;\n  margin-right: 3vw;\n  margin-top: 3.5vh;\n  margin-bottom: 0.5vw;\n}\n\n@media only screen and (max-height: 950px) {\n  .headerlink {\n    color: white;\n    font-size: 1rem;\n    font-weight: 700;\n    padding-left: 0%;\n    padding-right: 0%;\n    margin-left: 2vw;\n    margin-right: 3vw;\n    margin-top: 4vh;\n    margin-bottom: 0.5vw;\n  }\n  .navImg {\n    width: 50px;\n    /* height:auto */\n  }\n}\n\n@media only screen and (max-width: 384px) {\n  .navImg {\n    margin-top: 1vh;\n    margin-bottom: 1vh;\n  }\n\n  .headerlink {\n    color: white;\n    font-size: 0.71rem;\n    font-weight: 700;\n    padding-left: 0%;\n    padding-right: 0%;\n    margin-left: 2vw;\n    margin-right: 3vw;\n    margin-top: 3vh;\n    margin-bottom: 0.5vw;\n  }\n}\n\n@media only screen and (max-height: 384px) {\n  .headerlink {\n    color: white;\n    font-size: 1rem;\n    font-weight: 700;\n    padding-left: 0%;\n    padding-right: 0%;\n    margin-left: 2vw;\n    margin-right: 3vw;\n    margin-top: 6vh;\n    margin-bottom: 0.5vw;\n  }\n  .navImg {\n    width: 50px;\n    /* height:auto */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
